import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, normalizeClass as _normalizeClass, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "form-group" }
const _hoisted_2 = { class: "d-flex justify-content-between" }
const _hoisted_3 = {
  key: 0,
  class: "form-label text-muted"
}
const _hoisted_4 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_5 = ["disabled", "id"]
const _hoisted_6 = {
  key: 0,
  disabled: "",
  value: ""
}
const _hoisted_7 = ["value"]
const _hoisted_8 = { class: "invalid-feedback" }


export default /*@__PURE__*/_defineComponent({
  __name: 'SelectInput',
  props: {
    model: { default: () => ({}) },
    selectId: { default: "" },
    options: { default: () => [] },
    propertyForValue: { default: "id" },
    propertyForText: { default: "title" },
    label: { default: "" },
    errorMsg: { default: "Por favor, selecione uma opção" },
    placeholder: { default: "Escolha uma opção" },
    readOnly: { type: Boolean, default: false },
    required: { type: Boolean, default: false }
  },
  emits: ["selectChanged"],
  setup(__props: any, { emit: __emit }) {



const emit = __emit;

const onChange = (event: Event) => {
  emit("selectChanged", (event.target as HTMLSelectElement).value);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (__props.label)
        ? (_openBlock(), _createElementBlock("label", _hoisted_3, [
            _createTextVNode(_toDisplayString(__props.label) + " ", 1),
            (__props.required)
              ? (_openBlock(), _createElementBlock("i", _hoisted_4, "*"))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      _renderSlot(_ctx.$slots, "labelContentEnd")
    ]),
    _withDirectives(_createElementVNode("select", {
      disabled: __props.readOnly,
      class: _normalizeClass(["form-select", { 'is-invalid': __props.model.$error }]),
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((__props.model.$model) = $event)),
      onChange: _cache[1] || (_cache[1] = ($event: any) => (onChange($event))),
      id: __props.selectId
    }, [
      (__props.placeholder)
        ? (_openBlock(), _createElementBlock("option", _hoisted_6, _toDisplayString(__props.placeholder), 1))
        : _createCommentVNode("", true),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.options, (item, index) => {
        return (_openBlock(), _createElementBlock("option", {
          key: 'option_' + index,
          value: item[__props.propertyForValue]
        }, _toDisplayString(item[__props.propertyForText]), 9, _hoisted_7))
      }), 128))
    ], 42, _hoisted_5), [
      [_vModelSelect, __props.model.$model]
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("small", null, _toDisplayString(__props.errorMsg), 1)
    ])
  ]))
}
}

})